export const getAccountTransactions = {
    GET_ACCOUNT_TRANSACTIONS_REQUEST: "GET_ACCOUNT_TRANSACTIONS_REQUEST",
    GET_ACCOUNT_TRANSACTIONS_SUCCESS: "GET_ACCOUNT_TRANSACTIONS_SUCCESS",
    GET_ACCOUNT_TRANSACTIONS_ERROR: "GET_ACCOUNT_TRANSACTIONS_ERROR",
}

export const getAccountImpTransactions = {
    GET_ACCOUNT_IMP_TRANSACTIONS_REQUEST: "GET_ACCOUNT_IMP_TRANSACTIONS_REQUEST",
    GET_ACCOUNT_IMP_TRANSACTIONS_SUCCESS: "GET_ACCOUNT_IMP_TRANSACTIONS_SUCCESS",
    GET_ACCOUNT_IMP_TRANSACTIONS_ERROR: "GET_ACCOUNT_IMP_TRANSACTIONS_ERROR",
}

export const getAccountTransactionSummary = {
    GET_ACCOUNT_TRANSACTIONS_SUMMARY_REQUEST: "GET_ACCOUNT_TRANSACTIONS_SUMMARY_REQUEST",
    GET_ACCOUNT_TRANSACTIONS_SUMMARY_SUCCESS: "GET_ACCOUNT_TRANSACTIONS_SUMMARY_SUCCESS",
    GET_ACCOUNT_TRANSACTIONS_SUMMARY_ERROR: "GET_ACCOUNT_TRANSACTIONS_SUMMARY_ERROR",
}